



const railsConfig = {
  host:                     "devby.dev",
  protocol:                 "https",
  recaptcha_key:            "6LeMvlAfAAAAAEbMfZlQq3WDyiaEcq3uNYDLs5-q",
  bugsnag_frontend_key:     "781fe89ffd05447d6287220442a6ab20",
  lenta_static_assets_path: "https://static.devby.dev",
  login_path:               "/@/hello",
  logout_path:              "/@/bye",
  profile_path:             "/my",
  new_company_url:          "https://companies.devby.dev/new",
  stop_bot_url:             "/bots/unbind",
  bot_url:                  "https://t.me/staging_jobs_bot",
  privacy_policy_url:       "https://devby.dev/pages/privacy-policy",
  agreement_url:            "https://devby.dev/pages/polzovatelskoe-soglashenie",
  errorPageUrl:             "/errors"
};

export default railsConfig
